module.exports = __webpack_public_path__ + "static/media/icon_tip.8ebb6d7e.svg";